import React, { useEffect, useState } from 'react';

import { useMedia } from 'react-use';
import { SbCurrentUser } from '../submission_boards/component/SbModel';
import { CircleCheckIcon, CircleDotIcon, CircleIcon } from 'lucide-react';
import { MasterPlan, SubscriptionTier, UserPlan } from './UserPlanModal';
import Breadcrumb2 from '../shared/Breadcrumb2';
import Button from '../submission_boards/component/Button';
import { showToast } from '../shared/Toast';
import userService from '../services/UserService';
import { useIsMobile } from '../submission_boards/component/useIsMobile';

export interface DowngradePlanPageProps {
  currentUser: SbCurrentUser;
  user_plans: UserPlan[];
  master_plans: MasterPlan[];
  masterPlan: MasterPlan;
  is_pro_trial: boolean;
  is_premium_trial: boolean;
  closeDowngradePlanPage: () => void;
}

export default function DowngradePlanPage({
  currentUser,
  user_plans,
  master_plans,
  masterPlan,
  is_pro_trial,
  is_premium_trial,
  closeDowngradePlanPage,
}: DowngradePlanPageProps) {
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

  const isMobile = useIsMobile();

  const [newMasterPlan, setnewMasterPlan] = useState<MasterPlan | null>(null);
  const [masterPlans, setMasterPlans] = useState<MasterPlan[]>([]);
  const [userPlans, setUserPlans] = useState<UserPlan[]>([]);

  const [tabSelected, setTabSelected] = useState<string>('start');
  const [reasonSelected, setreasonSelected] = useState<string>('');
  const [otherReason, setOtherReason] = useState<string>('');

  enum TabOptions {
    Start = 'start',
    DowngradingConfirmFree = 'downgrading_confirm_free',
    DowngradingConfirmPro = 'downgrading_confirm_pro',
    Downgrading = 'downgrading',
    Redirecting = 'redirecting'
  }
  const reasons = [
    'Too expensive for me right now.',
    'I’m not using it enough.',
    'Missing key features I need.',
    'Switching to another platform.',
    'Other…',
  ];
  const cooridinatorpro_pro_archives = [
    { title: 'I don’t need it, just switch to Pro ($15/mo)', subscription_tier: SubscriptionTier.pro, name:'Pro' },
    { title: 'Switch to Pro with Idle Coordinator ($20/mo)', subscription_tier: SubscriptionTier.pro_idle, name:'Pro with Idle Coordinator' },
    { title: 'switch to Idle Coordinator ($5/mo)', subscription_tier: SubscriptionTier.archive, name:'Idle Coordinator' },
  ];

  const [cooridinatorpro_pro_archive_selected, setcooridinatorpro_pro_archive_selected] = useState(cooridinatorpro_pro_archives[0]);

  useEffect(() => {
    console.log('UserPlansPage useEffect currentUser');
    setUserPlans(user_plans);
    setMasterPlans(master_plans);
    setnewMasterPlan(masterPlan);
  }, [currentUser]);
  const cancelCurrentPlanHandler = async () => {
    try {
          let paymentUrl = `/users/manage_billing`;
          // const paymentUrl = `${redirecUrl}?prefilled_email=${currentUser.email}`;

          const reason1 = reasonSelected == '' ? otherReason: reasonSelected;
          const reason2 = "";
          const from_plan = '';
          const to_plan = newMasterPlan.plan_name;
          console.log("reason", reasonSelected, otherReason,
            "reason1", reason1,
            "to_plan", to_plan,
            "userPlans", userPlans,
          );
        await userService.downgradeReasonPost(reason1,reason2,from_plan,to_plan);
          if(is_pro_trial || is_premium_trial) {
            window.location.href = '/user_plans';
            return;
          } else {
            window.location.href = paymentUrl;
          }
          
      // const resp = await userService.cancelSubscription(newSetupMasterPlan.subscription_tier, newSetupMasterPlan.billing_cycle);
      // if (resp) {
      //   showToast('Cancelled your current subscription.', 'success');
      //   if(redirecUrl && redirecUrl !='') {
      //     let paymentUrl = `/users/manage_billing`;
      //     // const paymentUrl = `${redirecUrl}?prefilled_email=${currentUser.email}`;
      //     window.location.href = paymentUrl;
      //   } else { // only for basic we get 
      //     // mark subscription 
      //     window.location.href = "/user_plans";
      //   }
        // return;
      // }
    } catch (error) {
      showToast('Error while cancelling subscription.', 'danger');
    } finally {
    }
  };
  const getMasterPlanFor = (subscription_tier: string, billing_cycle: string) : MasterPlan => {
    const items = masterPlans.filter(
      (item) => item.subscription_tier == subscription_tier && item.billing_cycle == billing_cycle
    );
    if (items.length > 0) {
      return items[0];
    }
    return null;
  };

  return (
    <>
      {newMasterPlan != null && (
        <>
          <Breadcrumb2
            pages={[
              { name: 'Membership', href: '#', current: false },
              {
                name: 'Choose Your Plan',
                href: '#',
                current: false,
                onClick: () => {
                  closeDowngradePlanPage();
                },
              },
              {
                name: 'Downgrade',
                href: '#',
                current: true,
                onClick: () => {},
              },
            ]}
          ></Breadcrumb2>

          <div className="w-full flex flex-col flex-1 mx-auto px-4 sm:px-6 lg:px-8 pb-1">
            <div className="w-full max-w-6xl mx-auto relative py-14">
              <div className="flex flex-col pt-2 sm:px-48 gap-8 justify-center items-center">
                <div className="flex flex-row justify-center items-center gap-5 p-1 relative">
                  <div
                    className="absolute"
                    style={{
                      zIndex: 0,
                      border: '1px dashed #C0CADB',
                      height: 1,
                      left: 80,
                      right: 80,
                      top: 34,
                    }}
                  ></div>
                  <div className="flex flex-col justify-center items-center py-2 px-2 gap-1 z-10">
                    <div
                      className={
                        'w-10 h-10 rounded-full flex items-center justify-center' +
                        (tabSelected == TabOptions.Start
                          ? ' bg-blue-500 text-white  '
                          : ' bg-white border-blue-402 text-blue-402   ')
                      }
                      style={{
                        boxShadow: tabSelected == TabOptions.Start ? '0px 0px 0px 3px #3C82F633' : '',
                      }}
                    >
                      <CircleDotIcon className="w-6 h-6 " />
                    </div>
                    <div className="text-13 font-semibold text-gray-900 text-center">Reason for downgrade</div>
                  </div>
                  <div className="flex flex-col justify-center items-center py-2 px-2 gap-1 z-10">
                    <div
                      className={
                        'w-10 h-10 rounded-full flex items-center justify-center' +
                        (tabSelected == TabOptions.DowngradingConfirmFree ||
                          tabSelected == TabOptions.DowngradingConfirmPro || 
                          tabSelected == TabOptions.Downgrading
                          ? ' bg-blue-500 text-white  '
                          : ' bg-white border-blue-402 text-blue-402   ')
                      }
                      style={{
                        boxShadow:
                          tabSelected == TabOptions.DowngradingConfirmFree || 
                          tabSelected == TabOptions.DowngradingConfirmPro || 
                          tabSelected == TabOptions.Downgrading ? '0px 0px 0px 3px #3C82F633' : '',
                      }}
                    >
                      <CircleDotIcon className="w-6 h-6" />
                    </div>
                    <div className="text-13 font-semibold text-gray-900 text-center">Confirm downgrade</div>
                  </div>
                </div>
                {tabSelected == TabOptions.Start && (
                  <>
                    <div className="font-semibold text-5xl text-gray-900 justify-center items-center text-center">
                      We’d love to know what’s behind your decision
                    </div>
                    <div className="font-light text-2xl justify-center items-center text-center">
                      Why are you downgrading? Your feedback helps us make Filmik better for
                      everyone.
                    </div>
                    <div
                      className="flex flex-col max-w-lg gap-2-1"
                      style={{
                        minWidth: isMobile?'100%':'32rem',
                      }}
                    >
                      {reasons.map((reason, index) => {
                        return (
                          <div
                            key={index}
                            className="flex flex-row justify-start items-center p-4 gap-2-1 rounded-lg box-shadow-102 bg-white"
                          >
                            <div className="flex-1 flex flex-row justify-between items-center gap-2-1 truncate">
                              <div className="text-xs font-medium flex justify-start items-center truncate">
                                {reason}
                              </div>
                              {reason !== '' && (
                                <div className="text-green-600">
                                  <div
                                    className={
                                      reasonSelected && reason == reasonSelected
                                        ? 'text-blue-600'
                                        : 'text-gray-301'
                                    }
                                    onClick={(e) => {
                                      if ('Other…' !== reason) {
                                        setOtherReason('');
                                      }
                                      setreasonSelected(reason);
                                    }}
                                  >
                                    {reasonSelected && reason == reasonSelected ? (
                                      <CircleCheckIcon className="h-6 w-6" aria-hidden="true" />
                                    ) : (
                                      <CircleIcon className="h-6 w-6" aria-hidden="true" />
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                      {reasonSelected == 'Other…' && (
                        <div className="w-full flex flex-row">
                          <textarea
                            id={'requirements'}
                            name={'requirements'}
                            rows={4}
                            // value={notes}
                            className="outline-none block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6 focus:ring-2 focus:ring-inset focus:ring-blue-500"
                            placeholder={'Tell us briefly what led you to downgrade (optional)…'}
                            onChange={(e) => {
                              if (e.target.value.length > 512) {
                                showToast('You can add max 512 characters.', 'danger');
                                return;
                              }
                              setOtherReason(e.target.value);
                            }}
                            // message: 'Requirements cannot exceed 512 characters',
                          />
                        </div>
                      )}
                    </div>
                    <div className="justify-center items-center flex flex-col sm:flex-row gap-2-1">
                      <Button
                        variant="primary"
                        id="cancel_downgrade_btn_id"
                        btn_size="small"
                        icon_position="hor"
                        onClick={() => {
                          closeDowngradePlanPage();
                        }}
                      >
                        <span className="truncate">Keep my Current Plan</span>
                      </Button>
                      <Button
                        id="submit_downgrade_btn_id"
                        variant="secondary"
                        btn_size="small"
                        icon_position="hor"
                        type="button"
                        onClick={() => {
                          if(masterPlan.subscription_tier == SubscriptionTier.free ||
                            masterPlan.subscription_tier == SubscriptionTier.archive
                          )
                          {
                          setTabSelected(TabOptions.DowngradingConfirmFree);
                          }
                          else if(masterPlan.subscription_tier == SubscriptionTier.pro ||
                            masterPlan.subscription_tier == SubscriptionTier.pro_idle
                          )
                          {
                          setTabSelected(TabOptions.DowngradingConfirmPro);
                          }
                        }}
                      >
                        <span className="truncate">Downgrade to {newMasterPlan.plan_name}</span>
                      </Button>
                    </div>
                  </>
                )}
                {tabSelected == TabOptions.DowngradingConfirmFree && (
                    <>
                      <div className="font-semibold text-5xl text-gray-900 justify-center items-center text-center">
                        Please Confirm
                      </div>
                      <div className="font-light text-2xl justify-center items-center text-center">
                        You’re about to leave behind the benefits of your Filmik’s{' '}
                        <span className="font-semibold">Pro Membership</span>, including premium
                        tools and priority features.
                        <br></br>
                        Once you downgrade, these perks will no longer be available. Still want to
                        go ahead?
                      </div>

                      <div className="justify-center items-center flex flex-row gap-2-1">
                        <Button
                          variant="primary"
                          id="cancel_downgrade_btn_id"
                          btn_size="small"
                          icon_position="hor"
                          onClick={() => {
                            setTabSelected(TabOptions.Start);
                            closeDowngradePlanPage();
                          }}
                        >
                          <span className="truncate">Keep my Current Plan</span>
                        </Button>
                        <Button
                          id="submit_final_downgrade_btn_id"
                          variant="secondary"
                          btn_size="small"
                          icon_position="hor"
                          type="button"
                          onClick={async () => {
                          console.log("reason", reasonSelected, otherReason);
                            setTabSelected(TabOptions.Downgrading);
                            let stripe_url = newMasterPlan.stripe_url;
                            // let master_plan: MasterPlan | null = null;
                            // if(masterPlan.billing_cycle == 'month') {
                            //   master_plan = getMasterPlanFor(cooridinatorpro_pro_archive_selected.subscription_tier, 'month')
                            //   if(master_plan !=  null) {
                            //     stripe_url = master_plan.stripe_url;
                            //   }
                            // }
                            await cancelCurrentPlanHandler();
                          }}
                        >
                          <span className="truncate">Downgrade Anyway</span>
                        </Button>
                      </div>
                    </>
                  )}
                {tabSelected == TabOptions.DowngradingConfirmPro && (
                  <>
                    <div className="font-semibold text-5xl text-gray-900 justify-center items-center text-center">
                      Set Up Your Pro Plan
                    </div>
                    <div className="font-light text-2xl justify-center items-center text-center">
                      Your plan will change to Pro ($15/month). But wait!
                      <br></br>
                      For just <span className="font-semibold">$5 more</span>, you can add{' '}
                      <span className="font-semibold">Idle Coordinator</span> and keep continuous
                      access to your archived projects, so nothing you’ve built gets left behind.
                    </div>
                    <div
                      className="flex flex-col max-w-lg gap-2-1"
                      style={{
                        minWidth: isMobile?'100%': '32rem',
                      }}
                    >
                      {cooridinatorpro_pro_archives.filter((item2) => {
                        if(currentUser.subscription_tier == SubscriptionTier.pro_idle
                    && item2.subscription_tier == SubscriptionTier.pro_idle) {
                      return false;
                    } 
                    return true;
                  }
                    ).map((pro_proidle_archive, index) => {
                        return (
                          <div
                            key={index}
                            className="flex flex-row justify-start items-center p-4 gap-2-1 rounded-lg box-shadow-102 bg-white"
                          >
                            <div className="flex-1 flex flex-row justify-between items-center gap-2-1 truncate">
                              <div className="text-xs font-medium flex justify-start items-center truncate">
                                {pro_proidle_archive.title}
                              </div>
                              {pro_proidle_archive.title !== '' && (
                                <div className="text-green-600">
                                  <div
                                    className={
                                      cooridinatorpro_pro_archive_selected &&
                                      pro_proidle_archive.title == cooridinatorpro_pro_archive_selected.title
                                        ? 'text-blue-600'
                                        : 'text-gray-301'
                                    }
                                    onClick={(e) => {
                                      setcooridinatorpro_pro_archive_selected(pro_proidle_archive);
                                    }}
                                  >
                                    {cooridinatorpro_pro_archive_selected &&
                                    pro_proidle_archive.title == cooridinatorpro_pro_archive_selected.title ? (
                                      <CircleCheckIcon className="h-6 w-6" aria-hidden="true" />
                                    ) : (
                                      <CircleIcon className="h-6 w-6" aria-hidden="true" />
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="justify-center items-center flex flex-row gap-2-1">
                      <Button
                        id="cancel_downgrade_btn_id"
                        variant="secondary"
                        btn_size="small"
                        icon_position="hor"
                        onClick={() => {
                          setTabSelected(TabOptions.Start);
                          closeDowngradePlanPage();
                        }}
                      >
                        <span className="truncate">Back</span>
                      </Button>
                      <Button
                        id="submit_final_downgrade_btn_id"
                        variant="primary"
                        btn_size="small"
                        icon_position="hor"
                        type="button"
                        onClick={async () => {
                          setTabSelected(TabOptions.Downgrading);
                          let stripe_url = masterPlan.stripe_url;
                          let master_plan: MasterPlan |null = null;
                          let masterPlanTemp = masterPlan;
                          if(masterPlan.billing_cycle == 'month') {
                            let master_plan = getMasterPlanFor(cooridinatorpro_pro_archive_selected.subscription_tier, 'month')
                            if(master_plan !=  null) {
                              stripe_url = master_plan.stripe_url;
                              masterPlanTemp= master_plan;
                            }
                          }
                          console.log('master_plan', master_plan, 'stripe_url', stripe_url)
                          await cancelCurrentPlanHandler();
                        }}
                      >
                        <span className="truncate">
                          Subscribe 
                          {/* to{' '}
                          {cooridinatorpro_pro_archive_selected &&
                          cooridinatorpro_pro_archive_selected.subscription_tier != ''
                            ? cooridinatorpro_pro_archive_selected.subscription_tier
                            : 'Pro'} */}
                        </span>
                      </Button>
                    </div>
                  </>
                )}
                {tabSelected == TabOptions.Downgrading && (
                  <>
                    <div className="font-semibold text-5xl text-gray-900 justify-center items-center text-center">
                        Downgrading...
                    </div>
                  </>
                )}
                {tabSelected == TabOptions.Redirecting && (
                  <>
                    <div className="font-semibold text-5xl text-gray-900 justify-center items-center text-center">
                        Redirecting to Stripe…
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
